import React, { useEffect, useState } from "react";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import { ErrorCircleIcon } from "../../../constants/Icons";

function StockControl() {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { updateSettings } = useAuth();
  const { storeSettings } = usePermission();
  const toggleItems = [
    {
      key: "landingCost",
      label: "Landing Cost Multiplier",
      icon: "bx bx-calculator",
      settingLable: "isLandingCostMultiplier",
      color: "gray",
      subtext:
        "Use the multiplier to recalculate the landing cost (purchase cost including shipping and taxes). For example, 1.5 × ₹50 = ₹75. If this feature is disabled in settings, you can enter the landing cost manually.",
    },
    {
      key: "manufacture",
      label: "Manufacturing and Expiry Date",
      icon: "bx bx-calendar-edit",
      settingLable: "isManufactureAndExpiryDates",
      color: "gray",
      subtext: "When enabled, you'll be able to enter the date the Stock was Manufactured and its Expiry date while adding or updating Stocks in the store.",
    },
    // {
    //   key: "expire",
    //   label: "Expiry Date",
    //   icon: "bx bx-calendar-x",
    //   settingLable: "expiryDate",
    //   color: "#00d959",
    //   subtext: "Enable this option to allow Expiry Date.",
    // },
  ];

  //  Initialize toggle states dynamically
  const initialToggleState = toggleItems.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});
  const [toggles, setToggles] = useState(initialToggleState);

  //  Loading state for each toggle
  const [loading, setLoading] = useState(initialToggleState);

  //  Update toggle value in API
  const handleUpdate = async (value, key, settingLable) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    try {
      if (!checkNetwork()) return;

      const data = {
        stockSettings: {
          [settingLable]: value, //  Dynamic key usage
        },
      };

      const response = await AxiosInstance.patch(`module/storesettings`, data);
      const savedSettings = response.data?.results?.stockSettings || {};
      if (Object.prototype.hasOwnProperty.call(savedSettings, settingLable)) {
      showAlert("success", response.data.message);
     const newSettingsObject = {
        storeSettings: {
          stockSettings: {
            ...storeSettings.stockSettings,
            [settingLable]: value,
          },
        },
      }; 

  updateSettings(newSettingsObject);

      setToggles((prev) => ({ ...prev, [key]: value }));
    }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  // Fetch settings from API & set toggle states
  const handleList = async () => {
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(`module/storesettings`);
      const stockSettings = response.data?.results?.stockSettings || {};

      const updatedToggles = {};
      toggleItems.forEach((item) => {
        updatedToggles[item.key] = stockSettings[item?.settingLable] || false;
      });

      setToggles(updatedToggles);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSwitchChange = (event, key, settingLable) => {
    const newValue = event.target.checked;
    handleUpdate(newValue, key, settingLable);
  };

  useEffect(() => {
    handleList();
  }, []);

  return (
    <div className="row">
      <div className="col-lg-5">
        <div className="card">
          <div className="card-header p-3 bg-light-core">
            <h6 className="mb-0 text-dark">Stock Settings</h6>
          </div>
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-lg-12">
                {toggleItems.map(
                  ({ key, label, icon, color, settingLable, subtext }) => (
                    <div key={key} className="d-flex align-items-center">
                      <div>
                        <i
                          className={`${icon} font-27`}
                          style={{ color: toggles[key] ? color : "gray" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1 ms-2 align-items-center">
                        <label className="mb-0">
                          {label}
                          <span className="tooltip-container ms-1">
                            <span className="cursor-poInter"><ErrorCircleIcon/> </span>
                            <span
                              className="tooltip-text"
                              style={{ zIndex: 10 }}
                            >
                              {subtext}
                            </span>
                          </span>
                        </label>
                      </div>
                      <div className="ms-auto custom-toggle-wrapper">
                        <label className="custom-toggle">
                          <input
                            type="checkbox"
                            id={`${key}Toggle`}
                            checked={toggles[key]}
                            onChange={(event) =>
                              handleSwitchChange(event, key, settingLable)
                            }
                            disabled={loading[key]}
                          />
                          <span className="slider cursor-poInter">
                            {loading[key] ? (
                              <span
                                className={`spinner-inside ${
                                  toggles[key] ? "spinner-right" : ""
                                }`}
                              />
                            ) : (
                              <>
                                {toggles[key] ? (
                                  <span className="label-on ms-0-1">ON</span>
                                ) : (
                                  <span className="label-off ms-3">OFF</span>
                                )}
                              </>
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StockControl;
